/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React from "react";

import { ContentItem } from "@at/design-system-patterns";

export const carsFaqsContent: ContentItem[] = [
  {
    rowHeading: "How does car leasing work?",
    rowContent: (
      <>
        <p>
          Car leasing, also known as personal contract hire (PCH), is like
          renting. It’s a way of driving a brand new car without owning it. A
          lease is a financial agreement made with a funder, although leasing is
          often done through a lease provider who will sort everything for you.
        </p>
        <p>
          You simply choose the car you want, decide how much you want to pay
          upfront, how long you’d like to drive it for (usually between 2 and 5
          years) and how many miles you expect to drive in that time.
        </p>
        <p>
          This information is used by a funder to calculate your monthly
          payments and you can decide if the lease is right for you. If it is,
          your car will be delivered directly to your door and you get to drive
          it for the duration of your lease.
        </p>
        <p>
          At the end of your contract you simply hand the car back to the
          provider, so long as there is no damage (outside of usual wear and
          tear), and you have stayed within your agreed mileage.
        </p>
      </>
    ),
  },
  {
    rowHeading: "What happens at the end of leasing a car?",
    rowContent: (
      <>
        <p>
          At the end of your lease you simply hand the car back to the provider.
        </p>
        <p>
          They will get in touch a few months before your contract ends to
          discuss your options and arrange collection of the car.
        </p>
        <p>
          Be sure to perform a thorough check of the vehicle before it’s due to
          be returned so you have enough time to make any repairs outside of
          fair wear and tear.
        </p>
        <p>
          It’s important to be aware that you may need to pay excess charges if
          you have driven the car over the agreed mileage limit, or if the car
          is damaged beyond the expected fair wear and tear.
        </p>
        <p>
          <a href="/content/guides/returning-a-lease-car">
            Learn more about returning a car lease here
          </a>
        </p>
      </>
    ),
  },
  {
    rowHeading: "What is fair wear and tear?",
    rowContent: (
      <>
        <p>
          By the end of your lease, you will have been driving the car for 2 to
          5 years; ‘fair wear and tear’ is your funder demonstrating its
          understanding that your car won’t be in the same condition as it was
          when it was delivered. For example, a single small scratch on the
          paintwork could be considered ‘fair’, while a huge impact scrape would
          not.
        </p>
        <p>
          ‘Fair wear and tear’ means you don’t have to constantly worry about
          the condition of your vehicle and lets you enjoy driving it instead.
        </p>
      </>
    ),
  },
  {
    rowHeading: "What are the pros and cons of leasing?",
    rowContent: (
      <>
        <p>
          Leasing is a popular way to get a new car, but you need to make sure
          it’s right for you. Here are some advantages and disadvantages to keep
          in mind when making your decision.
        </p>
        <p>Pros:</p>
        <ul>
          <li>The initial payment is usually low.</li>
          <li>You’ll typically have lower monthly payments.</li>
          <li>
            The lease payments include road tax and the manufacturer’s warranty
            will often last for the majority of your lease.
          </li>
          <li>You don’t have to worry about the car’s depreciation.</li>
        </ul>
        <p>Cons:</p>
        <ul>
          <li>You’ll never own the car.</li>
          <li>
            You’ll face penalties for excess mileage or damage outside of fair
            wear and tear.
          </li>
          <li>Most contracts include fees for terminating your lease early.</li>
        </ul>
      </>
    ),
  },
  {
    rowHeading: "What fees should I be aware of when leasing a car?",
    rowContent: (
      <>
        <p>
          It’s important to consider all the fees and costs involved in leasing
          a car when you’re calculating your budget. Your agreement may include:
        </p>
        <br />
        <ul>
          <li>
            An initial rental, usually equivalent to 3, 6 or 9 months’ rentals.
            You can choose how much you want to put down as an initial rental
            and the more you pay at the start, the lower your monthly rentals
            will be.
          </li>
          <li>
            Late payment fees if you miss the date for your monthly rental.
          </li>
          <li>
            Excess mileages fees (sometimes per mile) if you go over what was
            agreed at the start of your lease.
          </li>
          <li>
            Repair fees on anything over ’fair wear and tear’, to be paid at the
            end of the lease.
          </li>
        </ul>
        <p>
          When leasing direct with Auto Trader you won’t pay any admin fees. The
          prices listed are also all for personal contract hire so all include
          VAT.
        </p>
      </>
    ),
  },
  {
    rowHeading: "Can I choose which funder I use when leasing my new car?",
    rowContent: (
      <p>
        You won’t be able to choose the funder yourself, as we automatically
        select the funder that offers the best deal for your selected lease and
        vehicle specification. We work with a trusted panel of funders so that
        we can make sure we’re always getting you the cheapest option available.
      </p>
    ),
  },
  {
    rowHeading: "What kind of credit score do you need to lease a car?",
    rowContent: (
      <>
        <p>
          As a car lease is a financial agreement, you will need to have a good
          credit score in order to get approved for a lease.
        </p>
        <p>
          Remember, how your credit score is measured can vary depending on the
          credit report you use. Similarly, funders will have different
          criteria, so whether you are approved for a lease may depend on the
          funder the deal is with.
        </p>
      </>
    ),
  },
  {
    rowHeading: "Do I need to arrange insurance for a leased car?",
    rowContent: (
      <>
        <p>
          Yes, lease cars do not come with insurance so when leasing, you will
          need to take out fully comprehensive insurance on your vehicle for the
          duration of your contract.
        </p>
        <p>
          When you take out an insurance policy, you‘ll need to let the
          insurance provider know that it‘s for a lease car and share the terms
          of the lease, alongside the name of the car‘s ‘registered owner‘
          (normally the funder) and the names of any additional drivers.
        </p>
        <p>
          You may also want to consider ‘gap insurance‘. Gap insurance protects
          against any difference there might be between the insurance company
          pay-out if your car is written off and the amount left to pay on your
          lease.{" "}
          <a href="/content/guides/car-leasing-with-insurance">
            You can learn more about insuring a lease car here.
          </a>
        </p>
      </>
    ),
  },
  {
    rowHeading: "How does Auto Trader make money from leasing?",
    rowContent: (
      <>
        <p>
          Auto Trader owns Vanarama, a vehicle leasing broker. As a regulated
          broker, Vanarama works with a selected group of funding partners to
          find you the best lease deal. Vanarama makes a commission on the deals
          and the commission will depend on the deal you choose and the funder
          the deal is with. Whilst you will not be charged any fees directly by
          Vanarama, the commission will be reflected in your monthly lease
          payments.
        </p>
      </>
    ),
  },
  {
    rowHeading: "Car leasing or buying: which is better?",
    rowContent: (
      <>
        <p>
          Whether you buy or lease your next car is purely down to you. Consider
          your budget, mileage and personal preference on owning a car.
        </p>
        <p>
          Leasing is a good choice if you want to drive a brand-new car every
          few years without owning one. It can work out cheaper per month than
          buying on finance or with cash. It also means you don’t have to worry
          about depreciation - the rate at which your car’s value drops over
          time - as you can simply hand it back at the end of your contract.
        </p>
        <p>
          If you’d prefer to own the car outright, buying may be the better
          choice for you. There are also no limits if you want to make any
          modifications to the car. Remember, you can also buy a car on finance
          and pay monthly rather than buying with cash.
        </p>
      </>
    ),
  },
  {
    rowHeading: "How does the 30 day money-back guarantee work?",
    rowContent: (
      <>
        <p>
          You have the right to return your vehicle up to 30 days after it has
          been delivered. The vehicle must not have more than 50 miles over the
          delivery mileage on the clock (as per the delivery mileage stated on
          the Delivery Acceptance Note). The vehicle will be inspected to BVRLA
          Fair Wear and Tear standards, although each lender has their own set
          of guidelines so it&apos; s worth checking these also. You will be
          liable for any damage not covered by your lender&apos;s fair wear &
          tear guidelines.
        </p>
        <p>
          For more information on our returns policy,{" "}
          <a href="https://www.vanarama.com/legal/terms-and-conditions/our-returns-policy">
            click here
          </a>
          .
        </p>
      </>
    ),
  },
];

export const vansFaqsContent: ContentItem[] = [
  {
    rowHeading: "How does van leasing work?",
    rowContent: (
      <>
        <p>
          Van leasing, also known as personal contract hire (PCH), is like
          renting, but for longer. It’s a way of driving a brand new van without
          owning it.
        </p>
        <p>
          A lease is a financial agreement made with a funder, although leasing
          is often done through a lease provider who will sort everything for
          you.
        </p>
        <p>
          You simply choose the van you want, decide how much you want to pay
          upfront, how long you’d like to drive it for (usually between 2 and 5
          years) and roughly how many miles you’ll do in that time.
        </p>
        <p>
          This information is used by a funder to work out your monthly payments
          and you can decide if the lease is right for you. If it is, your van
          will be delivered directly to your door and you can drive it for the
          duration of your lease.
        </p>
        <p>
          At the end of your contract, you simply hand the van back to the
          provider, so long as there is no damage (outside of usual wear and
          tear), and you have stayed within your agreed mileage.
        </p>
      </>
    ),
  },
  {
    rowHeading: "What happens at the end of leasing a van?",
    rowContent: (
      <>
        <p>
          At the end of your lease you can simply hand the van back and upgrade
          to a brand new model if you want to.
        </p>
        <p>
          They will get in touch a few months before your contract ends to
          discuss your options and arrange collection of the van.
        </p>
        <p>
          Be sure to perform a thorough check of the vehicle before it’s due to
          be returned so you have enough time to make any repairs outside of
          fair wear and tear.
        </p>
        <p>
          It’s important to be aware that you may need to pay excess charges if
          you have driven the van over the agreed mileage limit, or if the van
          is damaged beyond the expected fair wear and tear.
        </p>
        <p>
          <a href="/vans/content/what-happens-at-the-end-of-a-van-lease">
            Learn more about returning a van lease here.
          </a>
        </p>
      </>
    ),
  },
  {
    rowHeading: "What is fair wear and tear?",
    rowContent: (
      <>
        <p>
          By the end of your lease, you will have been driving the van for 2 to
          5 years. ‘Fair wear and tear’ is the understanding that your van won’t
          be in the same condition as it was when it was delivered. For example,
          a single small scratch on the paintwork could be considered ‘fair’,
          while a huge impact scrape would not.
        </p>
        <p>
          ‘Fair wear and tear’ means you don’t have to constantly worry about
          the condition of your vehicle and lets you enjoy driving it instead.
        </p>
      </>
    ),
  },
  {
    rowHeading: "What are the pros and cons of leasing?",
    rowContent: (
      <>
        <p>
          Leasing is a popular way to get a new vehicle, but you need to make
          sure it’s right for you. Here are some advantages and disadvantages to
          keep in mind when making your decision.
        </p>
        <p>Pros:</p>
        <ul>
          <li>The initial payment is usually low.</li>
          <li>You’ll typically have lower monthly payments.</li>
          <li>
            The lease payments include road tax and the manufacturer’s warranty
            will often last for the majority of your lease.
          </li>
          <li>You don’t have to worry about the van’s depreciation.</li>
        </ul>
        <p>Cons:</p>
        <ul>
          <li>You’ll never own the van.</li>
          <li>
            You’ll face penalties for excess mileage or damage outside of fair
            wear and tear.
          </li>
          <li>Most contracts include fees for terminating your lease early.</li>
          <li>You may have to pay more for specific colours or trim levels.</li>
        </ul>
      </>
    ),
  },
  {
    rowHeading: "What fees should I be aware of when leasing a van?",
    rowContent: (
      <>
        <p>
          There are sometimes extra fees and costs involved in leasing a van.
          Your agreement may include:
        </p>
        <br />
        <ul>
          <li>
            An initial payment usually equivalent to 3, 6 or 9-months’ payments.
          </li>
          <li>
            Administration fees, which are capped at £250 when leasing through
            Auto Trader.
          </li>
          <li>Late payment fees.</li>
          <li>
            Excess mileage fees (sometimes per mile) if you go over what was
            agreed at the start of your lease.{" "}
          </li>
          <li>
            Repair fees on anything over ‘fair wear and tear’, to be paid at the
            end of the lease.
          </li>
        </ul>
        <p>
          Also remember that prices listed don’t always include VAT, which
          you’ll have to pay unless you are a VAT-registered business.
        </p>
      </>
    ),
  },
  {
    rowHeading: "What kind of credit score do you need to lease a van?",
    rowContent: (
      <>
        <p>
          As a van lease is a financial agreement, you will need to have a good
          credit score in order to get approved for a lease.
        </p>
        <p>
          Remember, how your credit score is measured can vary depending on the
          credit report you use. Similarly, funders will have different
          criteria, so whether you are approved for a lease may depend on the
          funder the deal is with.
        </p>
      </>
    ),
  },
  {
    rowHeading: "Do I need to arrange insurance for a leased van?",
    rowContent: (
      <>
        <p>
          Very few van lease contracts include insurance, so you’ll need to
          arrange this yourself. When leasing, you will need to take out fully
          comprehensive insurance on your vehicle for the duration of the
          contract.
        </p>
        <p>
          When you take out an insurance policy, you’ll need to let the
          insurance provider know that it’s for a lease vehicle and share the
          terms of the lease, alongside the name of the van’s ‘registered owner’
          (normally the lease company) and the names of any additional drivers.
        </p>
        <p>
          You may also want to consider ‘gap insurance’. Gap insurance protects
          against any difference there might be between the insurance company
          pay-out if your van is written off and the amount left to pay on your
          lease.{" "}
          <a href="/vans/content/do-i-need-to-insure-a-leased-van">
            Learn more about insuring a lease vehicle
          </a>
        </p>
      </>
    ),
  },
  {
    rowHeading: "How does Auto Trader make money from leasing?",
    rowContent: (
      <>
        <p>
          Auto Trader owns Vanarama, a vehicle leasing broker. As a regulated
          broker, Vanarama works with a selected group of funding partners to
          find you the best lease deal. Vanarama makes a commission on the deals
          and the commission will depend on the deal you choose and the funder
          the deal is with. Whilst you will not be charged any fees directly by
          Vanarama, the commission will be reflected in your monthly lease
          payments.
        </p>
      </>
    ),
  },
  {
    rowHeading: "Van leasing or buying: which is better?",
    rowContent: (
      <>
        <p>
          Whether you buy or lease your next van is purely down to you. Consider
          your budget, mileage and personal preference on owning a van.
        </p>
        <p>
          Leasing is a good choice if you want to drive a brand-new van every
          few years without owning one. It can work out cheaper per month than
          buying on finance or with cash. It also means you don’t have to worry
          about depreciation — the rate at which your van’s value drops over
          time — as you can simply hand it back at the end of your contract.
        </p>
        <p>
          If you’d prefer to own the van outright, buying may be the better
          choice for you. There are also no limits if you want to make any
          modifications to the van. Remember, you can also buy a van on finance
          and pay monthly rather than buying with cash.
        </p>
      </>
    ),
  },
];
